import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';
import * as Chart from 'chart.js';

@Component({
  selector: 'app-ksp',
  templateUrl: './ksp.component.html',
  styleUrls: ['./ksp.component.css']
})
export class KspComponent implements OnInit, OnChanges {

  @ViewChild(BaseChartDirective, {static: true}) chart: BaseChartDirective;
  @Input() userKSP: any;
  maxVolume: number;
  greenActive: boolean = true;
  sizeSales: any[] = [];
  dataGrafActual: number[] = [];
  dataGrafExpected: number[] = [];
  dataGrafKSP: number[]= [];
  year: number[] = [];
  selectedIndex: number = 0;
  currentYear: number = 0;

  constructor() { }
//forlinechart

public lineChartOptions = {
  scaleShowVerticalLines: false,
  responsive: true,          
  hover: {
    mode: 'nearest'
  },
  legend: {display: false},
  tooltips: {
    callbacks: {
       label: function(tooltipItem) {
              return tooltipItem.yLabel;
       }
    }
  },
  plugins: {
    datalabels: {
      anchor: 'end',
      align: 'end',
      font: {
        size: 12,
        family: 'Gerbera',
      },
      formatter: function(value) {
        return value.toFixed(2) + '%';
      }
    }
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          suggestedMin: -20,
          display:false,
          stepSize: 5,
          max: 170
        },
        gridLines: {
          display: false,
          drawBorder: false,
        }
      }
    ],
    xAxes: [
      {
        display:false,
        gridLines:{
          display: false
        }
      }
    ]
  }
};
public lineChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
public lineChartType = 'bar';
public lineChartLegend = false;
public lineChartData = [
  {
    data:this.dataGrafKSP,
    label: "проценты КСП",
    type: 'line'
  }
];
public lineChartPlugins = [pluginDataLabels];
public lineChartColors = [
  {
    borderColor: 'rgb(219, 227, 136)',
    pointBackgroundColor: 'rgb(255, 255, 255)',
    borderWidth:2,
    pointRadius:5,
    fill: false,
    backgroundColor: "rgb(219, 227, 136)"
  }
];

  //for barchart

  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
    hover: {
      mode: 'nearest'
    },
    onHover: function(event){
      event 
    },
    legend: {
      position: 'bottom',
      reverse: true,
      labels:{
        boxWidth: 15,
        fontFamily: 'Gerbera',
        fontSize: 14,
        fontColor: '#636873',
        padding: 20
      },
      onClick: function(e, legendItem){
        var index = legendItem.datasetIndex;
        var ci = this.chart;
        var meta = ci.getDatasetMeta(index);
        if(index == 1){
          ci.options.plugins.datalabels.display = function(context){
            if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
              return false
            } else {
              return true
            }
          }
        }
        if(index == 0 || legendItem.hidden == true){
          ci.options.plugins.datalabels.display = function(context){
            if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
              return true
            } else {
              return false
            }
          }
        }
        meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
        ci.update()
      }
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
        offset: 10,
        font: {
          size: 12,
          weight: 300,
          family: 'Gerbera',
        },
        display: function(context){
          if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
            return true
          } else {
            return false
          }
        },
        color: function(context){
          if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
            return '#ADB837'
          } else{
            return '#E2C1E3'
          }
        },
        formatter: function(value, context) {
          if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
            return Math.round(value).toLocaleString();
          } else 
            return Math.round(value).toLocaleString();
        },
      }
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            suggestedMin: 0,
            display:false,
          },
          beforeBuildTicks: function(context){
            return context.max
          },
          gridLines: {
            display: false,
            drawBorder: false,
          }
        }
      ],
      xAxes: [
        {
          ticks:{
            fontFamily: 'Gerbera',
          },
          gridLines:{
            display: false
          }
        }
      ]
    }
  };
  public barChartLabels = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartData = [
    {
      data: this.dataGrafExpected, 
      label: 'ожидаемая сумма взносов тыс. ₽'
    },
    {
      data: this.dataGrafActual, 
      label: 'сумма фактически поступивших взносов тыс. ₽'
    }
  ];
  public barChartPlugins = [pluginDataLabels];
  public barChartColors = [
    {
      backgroundColor: 'rgb(226, 193, 227)' 
    },
    {
      backgroundColor: 'rgb(219, 227, 136)'
    },
    {
      borderColor: 'rgb(219, 227, 136)',
      pointBackgroundColor: 'rgb(219, 227, 136)',
      fill: false,
      backgroundColor: "rgb(219, 227, 136)"
    }
  ];

  ngOnInit() {
  }
 
  ngOnChanges() {
    if(this.userKSP.sales != undefined){
      this.sizeSales = this.userKSP.sales;
      let oldYear = null;
      this.currentYear = new Date().getFullYear();
      for(let item of this.sizeSales) {
        if(item.year != oldYear){
          oldYear = item.year;
          this.year.push(item.year);
        }
        
        if(item.year == this.currentYear){
          let recived_cash = item.recived_cash / 1000;
          let expected_fee = item.expected_fee / 1000;
          this.dataGrafActual.push(Math.round(recived_cash));
          this.dataGrafExpected.push(Math.round(expected_fee));
          this.dataGrafKSP.push(item.ksp);
        }
        this.barChartOptions = {
          scaleShowVerticalLines: false,
          responsive: true,
          hover: {
            mode: 'dataset'
          },
          onHover: function(event){
            event 
          },
          legend: {
            position: 'bottom',
            reverse: true,
            labels:{
              boxWidth: 15,
              fontFamily: 'Gerbera',
              fontSize: 14,
              fontColor: '#636873',
              padding: 20
            },
            onClick: function(e, legendItem){
              var index = legendItem.datasetIndex;
              var ci = this.chart;
              var meta = ci.getDatasetMeta(index);
              if(index == 0){

                if(legendItem.hidden == false){
                  ci.options.plugins.datalabels.display = function(context){
                    if(context.dataset.label == 'ожидаемая сумма взносов тыс. ₽'){
                      return false
                    }  else {
                      return true
                    }
                  }
                } else if(legendItem.hidden == true && this.greenActive == false){
                  ci.options.plugins.datalabels.display = function(context){
                    if(context.dataset.label == 'ожидаемая сумма взносов тыс. ₽'){
                      return true
                    }  else {
                      return false
                    }
                  }
                } else if(legendItem.hidden == true){
                  ci.options.plugins.datalabels.display = function(context){
                    if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
                      return true
                    }  else {
                      return false
                    }
                  }
                } 

              } else if(index == 1){

                if(legendItem.hidden == false){
                  this.greenActive = false;
                  ci.options.plugins.datalabels.display = function(context){
                    if(context.dataset.label == 'ожидаемая сумма взносов тыс. ₽'){
                      return true
                    }  else {
                      return false
                    }
                  }
                } else if(legendItem.hidden == true){
                  this.greenActive = true;
                  ci.options.plugins.datalabels.display = function(context){
                    if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
                      return true
                    }  else {
                      return false
                    }
                  }
                }
              }
              meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
              ci.update()
            }
          },
          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              offset: 10,
              font: {
                size: 12,
                weight: 300,
                family: 'Gerbera',
              },
              display: function(context){
                if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
                  return true
                } else {
                  return false
                }
              },
              color: function(context){
                if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
                  return '#ADB837'
                } else{
                  return '#E2C1E3'
                }
              },
              formatter: function(value, context) {
                if(context.dataset.label == 'сумма фактически поступивших взносов тыс. ₽'){
                  return Math.round(value).toLocaleString();
                } else 
                  return Math.round(value).toLocaleString();
              },
            }
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  suggestedMin: 0,
                  display:false
                },
                beforeBuildTicks: function(context){
                  return context.max = context.max * 1.7
                },
                gridLines: {
                  display: false,
                  drawBorder: false,
                }
              }
            ],
            xAxes: [
              {
                ticks:{
                  fontFamily: 'Gerbera',
                },
                gridLines:{
                  display: false
                }
              }
            ]
          }
        }
      }
      this.year.reverse();
      for(let year of this.year){
        if(year == this.currentYear){
          this.selectedIndex = this.year.indexOf(year);
        } else{
          this.selectedIndex = null
        }
      }
      this.dataGrafActual.reverse();
      this.dataGrafExpected.reverse();
      this.dataGrafKSP.reverse();
      this.chart.chart.update();
    }
  }

  onClickChangeYear(event:any, index: number){
    event.preventDefault();
    this.selectedIndex = index;
    this.dataGrafActual = [];
    this.dataGrafExpected = [];
    this.dataGrafKSP = [];
    this.chart.chart.update();
    var yearSelected = event.target.innerText;
    if(this.userKSP.sales != undefined){
      this.sizeSales = this.userKSP.sales;
      for(let item of this.sizeSales) {
        if(item.year == yearSelected){
          let recived_cash = item.recived_cash / 1000;
          let expected_fee = item.expected_fee / 1000;
          this.dataGrafActual.push(Math.round(recived_cash));
          this.dataGrafExpected.push(Math.round(expected_fee));
          this.dataGrafKSP.push(item.ksp);
        } 
      }
      this.dataGrafActual.reverse();
      this.dataGrafExpected.reverse();
      this.dataGrafKSP.reverse();
      this.barChartData = [
        {
          data: this.dataGrafExpected, 
          label: 'ожидаемая сумма взносов тыс. ₽'
        },
        {
          data: this.dataGrafActual, 
          label: 'сумма фактически поступивших взносов тыс. ₽'
        }
      ];
      this.lineChartData = [
        {
          data:this.dataGrafKSP,
          label: "проценты КСП",
          type: 'line'
        }
      ];
      this.chart.chart.update();

      return true;
    }
  }

}
